import moment from 'moment';
import EngagementLocationModel from './EngagementLocationModel';
export default class EngagementModel {
  id?: string;
  location?: any[];
  name: string;
  engagementItems?: any[];
  updatedAt?: string;

  constructor(data?: any) {
    this.id = data?.id || undefined;
    this.location = Array.isArray(data?.location) ? data.location.map(el => new EngagementLocationModel(el)) : [];
    this.name = data?.name || undefined;
    this.updatedAt = data?.updatedAt ? moment.unix(new Date(data.updatedAt).getTime() / 1000).format('ll') : undefined;
    this.engagementItems = data?.engagementItems || [];
  }
}
